import { useEffect } from 'react';
import { useStudio } from './studio-store';

export function usePlayback(): void {
  const isPlaying = useStudio((s) => s.isPlaying);
  const loop = useStudio((s) => s.loop);
  const seekFrame = useStudio((s) => s.seekFrame);
  const togglePlay = useStudio((s) => s.togglePlay);

  useEffect(() => {
    if (!isPlaying) return;
    let raf = 0;
    let last = performance.now();
    const step = (now: number) => {
      const state = useStudio.getState();
      const fps = state.project?.format.fps ?? state.selectedFormat?.fps ?? 24;
      const max = Math.max(
        state.project?.durationFrames ?? 0,
        Math.round(timelineSeconds(state) * fps)
      );
      const dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      const next = state.currentFrame + dt * fps;
      if (next >= max) {
        if (loop) {
          seekFrame(0);
        } else {
          togglePlay();
          return;
        }
      } else {
        seekFrame(next);
      }
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [isPlaying, loop, seekFrame, togglePlay]);
}

function timelineSeconds(state: {
  project: { durationSeconds: number } | null;
  tracks: Array<{ clips: Array<{ start: number; duration: number }> }>;
}): number {
  let max = state.project?.durationSeconds ?? 0;
  for (const track of state.tracks) {
    for (const clip of track.clips) {
      max = Math.max(max, clip.start + clip.duration);
    }
  }
  return max;
}
